import React from 'react';
import './libro_azul2.css';

// import libro_az from '../../../../assets/img/libros_azul.png';
import libro_az from '../../../../assets/img/libro_Azul.png'

export default class Libro_azul extends React.Component {
    render() {
        return (
            <div class='cont-libro-azul2'>
                <div class="contenedor escritorio">
                    <div class="row1">
                        <div class="col1">
                             <img src={ libro_az} alt="Imagen libro" class="libro" />
                            <img src={libro_az} alt="Imagen libro" class="libro_movil " />
                        </div>


                        {/* <div class="col2">
                            <img src="https://www.ricardosalinas.com/Content/assets/img/texto 1.png" alt="Imagen libro" class="letrero" />
                            <div class="div_bot">
                                <a class="buton" target="_blank" href="#">Más información</a>
                            </div>
                        </div> */}
                    </div>

                    {/* <div class="row2 ideasescr">
                        <div class="col21">
                            <p class="ideas"> Ideas sobre sociedad</p>
                            <div class="verde"></div>
                        </div>
                        <div class="col22">
                            <p class="ideas"> Ideas sobre libertad</p>
                            <div class="azul">
                            </div>
                        </div>
                        <div class="col23">
                            <p class="ideas"> Ideas sobre negocios</p>
                            <div class="gris">

                            </div>
                        </div>
                    </div> */}

                    {/* <div class="row2 movil">
                        <div class="col21">
                            <div class="azul"></div>
                            <p class="ideas"> Libertad</p>

                        </div>
                        <div class="col22">
                            <div class="verde"></div>
                            <p class="ideas"> Sociedad</p>


                        </div>
                        <div class="col23">
                            <div class="gris">

                            </div>
                            <p class="ideas"> Negocios</p>

                        </div>
                    </div> */}
                </div>


                {/* movil mas chiquito */}
                <div class="movil2">
                    <div class="row1">
                        <div class="col1">
                            <img src={ libro_az} alt="Imagen libro" class="libro_movil " />
                        </div>
                        {/* <div class="col2">
                            <img src="https://www.ricardosalinas.com/Content/assets/img/texto 1.png" alt="Imagen libro" class="letrero" />
                            <div class="div_bot">
                                <a class="buton" target="_blank" href="#">Más información</a>
                            </div>
                        </div> */}
                    </div>
                    {/* <div class="row2 movil">
                        <div class="col21">
                            <div class="azul"></div>
                            <p class="ideas"> Libertad</p>
                        </div>
                        <div class="col22">
                            <div class="verde"> </div>
                            <p class="ideas"> Sociedad</p>
                        </div>
                        <div class="col23">
                            <div class="gris">
                            </div>
                            <p class="ideas"> Negocios</p>

                        </div>
                    </div> */}
                </div>
            </div>
        );

    }

}